import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconPrint = createIcon({
  displayName: 'IconPrint',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M16 6H18V2H6V6H8V4H16V6ZM22 18H16V15H8V18H2V8H11V10H4V16H6V13H18V16H20V10H13V8H22V18ZM17 20H7V22H17V20Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
